export const OperacionLCLSCuentaFields = {
    NroCuenta: 'nroCuenta',
    RazonSocial: 'razonSocial',
    Moneda: 'moneda',
    CodClienteTipo: 'codOperacionLCLSClienteTipo',
    DescClienteTipo: 'descClienteTipo',
    CodClienteSubTipo: 'codOperacionLCLSClienteSubTipo',
    DescClienteSubTipo: 'descClienteSubTipo',
    LimiteConcertacion: 'limiteConcertacion',
    LimiteLiquidacionDVP: 'limiteLiquidacionDVP',
    LimiteLiquidacionFOP: 'limiteLiquidacionFOP',
} as const

export const OperacionLCLSFields = {
    CodOperacionLCLS: 'codOperacionLCLS',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    DescSectorComercial: 'descSectorComercial',

    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    Observaciones: 'observaciones',

    Cuentas: 'cuentas',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
    Monto: 'monto',

} as const

export const OperacionLCLSCuentaLimiteFields = {
    CodGrupo: 'codGrupo',
    DescGrupo: 'descGrupo',
    LimiteConcertacion: 'limiteConcertacion',
    LimiteLiquidacionDVP: 'limiteLiquidacionDVP',
    LimiteLiquidacionFOP: 'limiteLiquidacionFOP',
    PermiteModificar: 'permiteModificar',
    FechaAccion: 'fechaAccion'
} as const;

export const OperacionLCLSLimiteAprobadoFields = {
    CodPais: 'codPais',
    CodSistema: 'codSistema',
    CodUnidadNegocio: 'codUnidadNegocio',
    NroCuenta: 'nroCuenta',
    RazonSocial: 'razonSocial',
    Moneda: 'moneda',
    LimiteConcertacion: 'limiteConcertacion',
    LimiteDVP: 'limiteDVP',
    LimiteFOP: 'limiteFOP',
    FechaAlta: 'fechaAlta',
    UsuarioUltMod: 'usuarioUltMod',
    IdMensaje: 'idMensaje',
    FechaAprobacion: 'fechaAprobacion',
    NombrePais: 'nombrePais',
    CodSistemaPrincipal: 'codSistemaPrincipal',
} as const;

export const OperacionLCLSLimitesAprobadosUnidadNegocioFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    ListaLimites: 'limites'
} as const;

export const OperacionLCLSLimitesAprobadosPaisFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    FechaUltMod: 'fechaUltMod',
    UsuarioUltMod: 'usuarioUltMod',
    IdMensaje: 'idMensaje',
    FechaAprobacion: 'fechaAprobacion',
    ListaUnidadesNegocio: 'unidadesNegocio'
} as const;


export const OperacionLCLSRelacionFields = {
    CodSectorComercial: 'codSectorComercial',
    CodClienteTipo: 'codClienteTipo',
    CodClienteSubTipo: 'codClienteSubTipo',
    DescClienteTipo: 'descClienteTipo',
    DescClienteSubTipo: 'descClienteSubTipo',
} as const;


export const OperacionLCLSUnidadNegocioFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
} as const;

export const OperacionLCLSSectorComercialFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
    CodSectorComercial: 'codSectorComercial'
} as const;

